var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewconversation = function SvgNewconversation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 16.3943V2.05775C0.25 1.56058 0.427 1.135 0.781 0.781C1.135 0.427 1.56058 0.25 2.05775 0.25H13.9423C14.4394 0.25 14.865 0.427 15.219 0.781C15.573 1.135 15.75 1.56058 15.75 2.05775V7.04625C15.625 7.02575 15.5 7.01292 15.375 7.00775C15.25 7.00258 15.125 7 15 7C14.875 7 14.75 7.00258 14.625 7.00775C14.5 7.01292 14.375 7.02575 14.25 7.04625V2.05775C14.25 1.96792 14.2212 1.89417 14.1635 1.8365C14.1058 1.77883 14.0321 1.75 13.9423 1.75H2.05775C1.96792 1.75 1.89417 1.77883 1.8365 1.8365C1.77883 1.89417 1.75 1.96792 1.75 2.05775V12.25H9.04625C9.02575 12.375 9.01292 12.5 9.00775 12.625C9.00258 12.75 9 12.875 9 13C9 13.125 9.00258 13.25 9.00775 13.375C9.01292 13.5 9.02575 13.625 9.04625 13.75H2.89425L0.25 16.3943ZM4.05775 5.75H11.9423V4.25H4.05775V5.75ZM4.05775 9.75H8.94225V8.25H4.05775V9.75ZM14.25 16.75V13.75H11.25V12.25H14.25V9.25H15.75V12.25H18.75V13.75H15.75V16.75H14.25Z",
    fill: "#5F5F75"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewconversation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newconversation.b7a72c29.svg";
export { ForwardRef as ReactComponent };